// @ts-nocheck
export const homeButtonHandler = ({
    navigate
}) => {
    navigate?.('/create-event');
};

export const newEventHandler = ({
    navigate
}) => {
    navigate?.('/create-event');
};